// extracted by mini-css-extract-plugin
module.exports =  {"root":"XO4S0l5uYwuP9dFQy6Bh"};